import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/user-manager',
    name: 'userManager',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/system/UserManager.vue'),
  },
];
